<template>
  <div id="app-div">
    <div style="width: 100%; margin: 0; padding: 0">
      <div>
        <label style="margin-right: 20px; margin-left: 180px">模版类型：</label>
        <label v-if="emailTemplate.templateType == '2'">收稿</label>
        <label v-if="emailTemplate.templateType == '5'">审稿</label>
        <label v-if="emailTemplate.templateType == '6'">催审</label>
        <label v-if="emailTemplate.templateType == '8'">缴费</label>
        <label v-if="emailTemplate.templateType == '9'">催缴</label>
        <label v-if="emailTemplate.templateType == '3'">退改</label>
        <label v-if="emailTemplate.templateType == '4'">退稿</label>
        <label v-if="emailTemplate.templateType == '7'">采用</label>
      </div>

      <div style="margin-top: 15px">
        <label style="margin-right: 20px; margin-left: 150px"
          >邮件模版语言：</label
        >
        <label v-if="emailTemplate.lang == 'CN'">中文</label>
        <label v-if="emailTemplate.lang == 'EN'">英文</label>
      </div>

      <div style="margin-top: 15px">
        <label style="margin-right: 20px; margin-left: 150px"
          >邮件模版名称：</label
        >
        {{ emailTemplate.name }}
      </div>

      <div style="margin-top: 15px">
        <label style="margin-right: 20px; margin-left: 180px">邮件标题：</label>
        {{ emailTemplate.title }}
      </div>

      <div style="margin-top: 15px; width: 100%">
        <div style="float: left; margin-left: 180px">邮件内容：</div>
        <!-- <div
          contenteditable="true"
          style="height:250px;width:600px;border:1px solid #BCBCBC;margin-left:275px; overflow-y:scroll;"
        >
          尊敬的[user_real_name][sex]：您好！您的稿件《[title]》（稿件编号：[file_no]）已被退稿。
          具体退稿意见如下： [discard_advice] 您的稿件未能接收，我们深表遗憾。
          ========================================================
          我们的网址是[web_site] 您的用户名为：[user_name]，密码为：[password]
          ========================================================
          我们的地址是[address]，电话[telephone]，邮箱[E-mail]再次感谢您的投稿[unit name] [date]
        </div>-->
        <a-textarea
          v-model="emailTemplate.content"
          style="
            height: 250px;
            width: 600px;
            border: 1px solid #bcbcbc;
            margin-left: 20px;
          "
          v-bind:read-only="isEnable"
        ></a-textarea>
      </div>

      <div style="margin-top: 20px">
        <label style="margin-right: 20px; margin-left: 180px">状态启用：</label>
        <label v-if="emailTemplate.status == 1">启用</label>
        <label v-if="emailTemplate.status == 0">禁用</label>
        <label style="margin-right: 20px; margin-left: 180px">查看变量：</label>
        <a-switch
          unCheckedChildren="关"
          checkedChildren="开"
          defaultunChecked
          @change="changeState"
        />
        <div
          v-if="state"
          style="
            height: 200px;
            width: 600px;
            border: 1px solid #bcbcbc;
            margin-top: 10px;
            margin-left: 275px;
            overflow-y: scroll;
          "
        >
          邮件内容关键词是系统可以自动提供的，只要在模板中增加后，系统会自动用真实数据替换，请根据需要
          选择关键词。
          <br />[user_real_name]：作者真实姓名 <br />[sex]：性别
          <br />[title]：稿件标题 <br />[file_no]：稿件编号
          <br />[discard_advice]：退稿意见 <br />[web_site]：网址
          <br />[user_name]：用户名 <br />[password]：密码 <br />[address]：地址
          <br />[telephone]：电话 <br />[E-mail]：邮箱
        </div>
      </div>

      <div style="margin-top: 50px; margin-left: 700px">
        <a-button style="margin-right: 50px" @click="cancelAdd()"
          >关闭</a-button
        >
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      state: false,
      count: false,
      emailTemplate: { templateType: '2', lang: 'CN', status: 1 },
      currentMode: 'add',
      isChecked: true,
      isEnable: false
    };
  },
  created() {
    var methed = this.$route.query.methed;
    this.currentMode = methed;
    if ('add' != methed) {
      var record = JSON.parse(this.$route.query.record);
      this.emailTemplate = record;
    }

    if ('look' == methed) {
      this.isEnable = true;
    }
  },
  methods: {
    handleChange() {},
    typeChange() {},
    statusChange(e) {
      if (e.target.checked) {
        this.isChecked = true;
        this.emailTemplate.status = 1;
      } else {
        this.isChecked = false;
        this.emailTemplate.status = 0;
      }
    },
    changeState() {
      this.state = !this.state;
    },
    cancelAdd() {
      this.$router.push({
        path: '/Email'
      });
    },
    submit() {
      if (this.emailTemplate.name == '') {
        this.utils.messageInfo(this, 'error', '邮件模版名称不能为空！');
        return;
      } else if (this.emailTemplate.title == '') {
        this.utils.messageInfo(this, 'error', '邮件标题不能为空！');
        return;
      } else if (this.emailTemplate.content == '') {
        this.utils.messageInfo(this, 'error', '邮件内容不能为空！');
        return;
      }

      if (this.currentMode == 'add') {
        this.axios
          .post('/emailTemplate/saveEmailTemplate', {
            templateType: this.emailTemplate.templateType,
            lang: this.emailTemplate.lang,
            name: this.emailTemplate.name,
            title: this.emailTemplate.title,
            content: this.emailTemplate.content,
            status: this.emailTemplate.status,
            creater: sessionStorage.getItem('userCode')
          })
          .then((res) => {
            if (res.data.code == 'OK') {
              this.utils.messageInfo(this, 'success', '添加成功');
              this.$router.push({
                path: '/Email'
              });
            } else {
              this.utils.messageInfo(this, 'error', '添加失败！');
            }
          });
      } else if (this.currentMode == 'edit') {
        this.axios
          .post('/emailTemplate/updateEmailTemplate', {
            templateCode: this.emailTemplate.templateCode,
            templateType: this.emailTemplate.templateType,
            lang: this.emailTemplate.lang,
            name: this.emailTemplate.name,
            title: this.emailTemplate.title,
            content: this.emailTemplate.content,
            status: this.emailTemplate.status
          })
          .then((res) => {
            if (res.data.code == 'OK') {
              this.utils.messageInfo(this, 'success', '编辑成功');
              this.$router.push({
                path: '/Email'
              });
            } else {
              this.utils.messageInfo(this, 'error', '编辑失败！');
            }
          });
      }
    }
    // countDown(count) {
    //   this.count = !this.count;
    //   let secondsToGo = 3;
    //   const modal = this.$success({
    //     title: "操作成功！",
    //     content: `${secondsToGo}秒后自动关闭`
    //   });
    //   const interval = setInterval(() => {
    //     secondsToGo -= 1;
    //     modal.update({
    //       content: `${secondsToGo}秒后自动关闭`
    //     });
    //   }, 1000);
    //   setTimeout(() => {
    //     clearInterval(interval);
    //     modal.destroy();
    //   }, secondsToGo * 1000);
    // }
  }
};
</script>
<style>
</style>


